import { getValidSubtypesForCategory } from 'src/Components/Forms/PracticalInformation/PracticalInformationForm/PracticalInformationCategoryMapping.helper';
import {
  CreatePracticalInformationDtoSubtypeEnum,
  CreatePracticalInformationDtoTypeEnum,
} from 'src/Services/API/generated';

export interface PracticalInformationSuggestion {
  subtype: CreatePracticalInformationDtoSubtypeEnum;
  labelKey: string;
  labelDefault: string;
  descriptionKey: string;
  descriptionDefault: string;
}

export const PRACTICAL_INFORMATION_SUGGESTIONS: PracticalInformationSuggestion[] = [
  {
    subtype: CreatePracticalInformationDtoSubtypeEnum.WifiCodeAndRouterSetup,
    labelKey: 'practicalInformation.suggestions.wifiCodeAndRouterSetup.label',
    labelDefault: 'Wifi : code et box',
    descriptionKey: 'practicalInformation.suggestions.wifiCodeAndRouterSetup.description',
    descriptionDefault: 'Le nom du réseau, le mot de passe, où se trouve la box.',
  },
  {
    subtype: CreatePracticalInformationDtoSubtypeEnum.KeysBadgesAccessCodes,
    labelKey: 'practicalInformation.suggestions.keysBadgesAccessCodes.label',
    labelDefault: "Clés, badges et codes d'accès",
    descriptionKey: 'practicalInformation.suggestions.keysBadgesAccessCodes.description',
    descriptionDefault: 'Où sont les doubles, codes du portail et de la boîte à clés.',
  },
  {
    subtype: CreatePracticalInformationDtoSubtypeEnum.UtilityMetersAndValvesLocation,
    labelKey: 'practicalInformation.suggestions.utilityMetersAndValvesLocation.label',
    labelDefault: "Compteurs et vannes d'arrêt",
    descriptionKey: 'practicalInformation.suggestions.utilityMetersAndValvesLocation.description',
    descriptionDefault: 'Eau, électricité, gaz : où couper en cas de fuite ou de panne.',
  },
  {
    subtype: CreatePracticalInformationDtoSubtypeEnum.GarbageCollection,
    labelKey: 'practicalInformation.suggestions.garbageCollection.label',
    labelDefault: 'Collecte des déchets',
    descriptionKey: 'practicalInformation.suggestions.garbageCollection.description',
    descriptionDefault: 'Jours de ramassage, consignes de tri, où sortir les bacs.',
  },
  {
    subtype: CreatePracticalInformationDtoSubtypeEnum.HeatingType,
    labelKey: 'practicalInformation.suggestions.heatingType.label',
    labelDefault: 'Chauffage : type et fonctionnement',
    descriptionKey: 'practicalInformation.suggestions.heatingType.description',
    descriptionDefault: "Comment l'allumer, le régler, le couper en partant.",
  },
  {
    subtype: CreatePracticalInformationDtoSubtypeEnum.WaterHeaterBoilerOperation,
    labelKey: 'practicalInformation.suggestions.waterHeaterBoilerOperation.label',
    labelDefault: 'Chauffe-eau / ballon',
    descriptionKey: 'practicalInformation.suggestions.waterHeaterBoilerOperation.description',
    descriptionDefault: "Remise en route à l'arrivée, position des disjoncteurs.",
  },
  {
    subtype: CreatePracticalInformationDtoSubtypeEnum.HomeBoatCamperInsurance,
    labelKey: 'practicalInformation.suggestions.homeBoatCamperInsurance.label',
    labelDefault: 'Assurance habitation',
    descriptionKey: 'practicalInformation.suggestions.homeBoatCamperInsurance.description',
    descriptionDefault: 'Assureur, n° de contrat, échéance, que faire en cas de sinistre.',
  },
];

const subtypeToTypeMap = (() => {
  const map = new Map<
    CreatePracticalInformationDtoSubtypeEnum,
    CreatePracticalInformationDtoTypeEnum
  >();
  Object.values(CreatePracticalInformationDtoTypeEnum).forEach(type => {
    const subtypes = getValidSubtypesForCategory(type);
    subtypes?.forEach(subtype => map.set(subtype, type));
  });
  return map;
})();

export const getTypeForSubtype = (
  subtype: CreatePracticalInformationDtoSubtypeEnum
): CreatePracticalInformationDtoTypeEnum | undefined => subtypeToTypeMap.get(subtype);
